module.exports = __webpack_public_path__ + "224bd02e5883df9d50a93e4a8c59c782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/r2d2-logo.png
// module id = 1060
// module chunks = 0